<template>
  <div class="chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default {
  props: { data: { type: Array, default: () => [] } },
  setup(props) {
    const chartCanvas = ref(null);
    let chartInstance = null;

    const createChart = () => {
      if (!props.data?.length) return;

      if (chartInstance) chartInstance.destroy();

      chartInstance = new Chart(chartCanvas.value, {
        type: 'bar',
        data: {
          labels: props.data.map(i => i.x),
          datasets: [
            {
              label: 'ALERTAS',
              data: props.data.map(i => i.y),
              backgroundColor: '#cfe8e8',
              borderColor: '#3c5d5d',
              borderWidth: 1,
            },
          ],
        },
        options: {
            indexAxis: 'y',
            responsive: true,
            plugins: {
                legend: { onClick: null },
            },
            scales: {
                x: {
                title: { display: true, text: 'Alertas' },
                beginAtZero: true,
                },
                y: {
                title: { display: false },
                },
            },
        },
      });
    };

    onMounted(createChart);
    watch(() => props.data, createChart);

    return { chartCanvas };
  },
};
</script>

<style scoped>
.chart-container{
  width: 100%;
  height: 260px;
  margin: 0 auto;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
canvas{
  width: 100% !important;
  height: 100% !important;
}
</style>
